import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import DynamicTable from '../../../../../components/DynamicTable/DynamicTable';
import { USER_DATA } from '../../../../../config/roles_and_permissions';
import CustomPagination from '../../../../../components/Pagination/CustomPagination';
import { useDispatch, useSelector } from 'react-redux';
import { getAllOfficerList, getAllRoles, getOfficers } from '../../../../../redux/UserReducer/action';
import PermissionDrawer from '../../../components/PermissionDrawer/PermissionDrawer';
import { Button, Col, Form, Row } from 'react-bootstrap';
import '../../RolesPermissionsDashboard/RolesPermissionsDashboard.css';
import FilledButton from '../../../../../components/Buttons/FilledButton';
import ChangeRoleModal from '../../../components/ChangeRoleModal/ChangeRoleModal';


const UsersPermissionsDashboard = () => {

    const { officers, officerPagination, rolesList, rolesPagination } = useSelector((store) => {
        return {
            officers: store.UserReducer.officerList.officers,
            officerPagination: store.UserReducer.officerList.pagination,
            rolesList: store.UserReducer.roles.rolesList,
            rolesPagination: store.UserReducer.roles.pagination,
        }
    }, []);

    useEffect(() => {
        console.log("User data from Redux (officers): ", officers);
    }, [officers]);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [selectedUser, setSelectedUser] = useState(null);
    const [roleChangeUser, setRoleChangeUser] = useState(null);
    
 

    let storedOfficerFilters = JSON.parse(sessionStorage.getItem("officerFilters"));
    let [officerFilters, setOfficerFilters] = useState({
        role_code: '' || storedOfficerFilters?.role_code,
        officer_id: '' || storedOfficerFilters?.officer_id,
        is_active: '' || storedOfficerFilters?.is_active,
        global_search: '' || storedOfficerFilters?.global_search
    });

    const handleClearFilters = () => {
        setOfficerFilters({ global_search: '', role_code: '', is_active: '', officer_id: '' });
        handlePageChange(1);
    };

    const [currentPage, setCurrentPage] = useState(parseInt(sessionStorage.getItem('currentPage')) || 1);
    const [limit, setLimit] = useState(parseInt(sessionStorage.getItem('limit')) || 10);
    const [allRolesLimit, setAllRolesLimit] = useState(2000);
    const totalCount = parseInt(sessionStorage.getItem('totalCount')) || 0;
    const totalPages = Math.ceil(totalCount / limit);

    useEffect(() => {
        dispatch(getAllOfficerList(currentPage, limit, officerFilters));

        sessionStorage.setItem("officerFilters", JSON.stringify(officerFilters));
    }, [dispatch, currentPage, limit, officerFilters]);

    useEffect(() => {
        dispatch(getAllRoles(1, allRolesLimit, {}));
    }, [dispatch, allRolesLimit]);

    const handleAction = (action, user) => {
        if (action === 'manage-permissions') {
            setSelectedUser(user);
        } else if (action === 'change-role') {
            setRoleChangeUser(user);
        }
    };

    const handlePageChange = (newPage) => {
        // Ensure we're working with 1-based pagination
        const pageToSet = Math.max(1, Math.min(newPage, totalPages));
        setCurrentPage(pageToSet);
        sessionStorage.setItem('currentPage', pageToSet.toString());
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        let finalValue;

        if(name === "is_active"){
            finalValue = value === "" ? "" : value === "true";
        }
        else {
            finalValue = value;
        }

        setOfficerFilters(prev => ({
            ...prev,
            [name]: finalValue
        }));

        handlePageChange(1);
    }

    return (
        <div>
            <div>

                <div className="user-filters">
                    <Row className="g-2 align-items-center">

                        {/* Search */}
                        <Col md={4}>
                            <Form.Control
                                name='global_search'
                                type="text"
                                placeholder="Search by name, email or role"
                                value={officerFilters.global_search}
                                onChange={handleChange}
                            />
                        </Col>

                        {/* Role Filter */}
                        <Col md={3}>
                            <Form.Select
                                name='role_code'
                                value={officerFilters.role_code}
                                onChange={handleChange}
                            >
                                <option value="">All Roles</option>
                                {
                                    [...new Set(rolesList?.map(role => role?.short_name))]
                                    .filter(Boolean)
                                    ?.map((shortName) => (
                                        <option key={shortName} value={shortName}>{shortName}</option>
                                    ))
                                }
                            </Form.Select>
                        </Col>

                        {/* Status Filter */}
                        <Col md={3}>
                            <Form.Select
                                name="is_active"
                                value={officerFilters.is_active === true ? "true" : 
                                    officerFilters.is_active === false ? "false" : 
                                ''}
                                onChange={handleChange}
                            >
                                <option value="">All Status</option>
                                <option value="true">Active</option>
                                <option value="false">Inactive</option>
                            </Form.Select>
                        </Col>

                        <Col md="auto">
                            {/* <Button
                                className='filter-clr-btn'
                                // variant="outline-secondary"
                                onClick={handleClearFilters}
                            >
                                Clear
                            </Button> */}
                            <FilledButton
                                title={"Clear"}
                                handleClick={handleClearFilters}
                            />
                        </Col>

                    </Row>
                </div>

                <div className='dynamic-table-container'>
                    <DynamicTable
                        columns={USER_DATA}
                        data={officers}
                        onAction={handleAction}
                    />
                </div>

                {
                    officers?.length > 0 &&
                    <CustomPagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    />
                }
            </div>

            <PermissionDrawer
                user={selectedUser}
                onClose={() => setSelectedUser(null)}
                currentPage={currentPage}
                limit={limit}
                officerFilters={officerFilters}
            />

            <ChangeRoleModal
                show={!!roleChangeUser}
                onHide={() => setRoleChangeUser(null)}
                user={roleChangeUser}
                currentPage={currentPage}
                limit={limit}
                officerFilters={officerFilters}
            />
        </div>
    )
}

export default UsersPermissionsDashboard